export enum CountryAbbreviation {
  USA = "USA",
  CAN = "CAN",
  MEX = "MEX",
  BRA = "BRA",
  ARG = "ARG",
  COL = "COL",
  PER = "PER",
  VEN = "VEN",
  CHL = "CHL",
  ECU = "ECU",
  GTM = "GTM",
  CUB = "CUB",
  SLV = "SLV",
  UK = "UK",
  FR = "FR",
  DE = "DE",
  IT = "IT",
  ES = "ES",
  NL = "NL",
  SE = "SE",
  NO = "NO",
  CH = "CH",
  BE = "BE",
  PL = "PL",
  PT = "PT",
  IE = "IE",
  GR = "GR",
  DK = "DK"
}

export type CountryInfo = {
  code: string;
  abbreviation: CountryAbbreviation;
  phoneDigits: number;
  iso2: string;
};

export const CountryCodes: Record<CountryAbbreviation, CountryInfo> = {
  [CountryAbbreviation.USA]: {
    code: "1",
    abbreviation: CountryAbbreviation.USA,
    phoneDigits: 10,
    iso2: "us",
  },
  [CountryAbbreviation.CAN]: {
    code: "1",
    abbreviation: CountryAbbreviation.CAN,
    phoneDigits: 10,
    iso2: "ca",
  },
  [CountryAbbreviation.MEX]: {
    code: "52",
    abbreviation: CountryAbbreviation.MEX,
    phoneDigits: 10,
    iso2: "mx",
  },
  [CountryAbbreviation.BRA]: {
    code: "55",
    abbreviation: CountryAbbreviation.BRA,
    phoneDigits: 11,
    iso2: "br",
  },
  [CountryAbbreviation.ARG]: {
    code: "54",
    abbreviation: CountryAbbreviation.ARG,
    phoneDigits: 10,
    iso2: "ar",
  },
  [CountryAbbreviation.COL]: {
    code: "57",
    abbreviation: CountryAbbreviation.COL,
    phoneDigits: 10,
    iso2: "co",
  },
  [CountryAbbreviation.PER]: {
    code: "51",
    abbreviation: CountryAbbreviation.PER,
    phoneDigits: 9,
    iso2: "pe",
  },
  [CountryAbbreviation.VEN]: {
    code: "58",
    abbreviation: CountryAbbreviation.VEN,
    phoneDigits: 10,
    iso2: "ve",
  },
  [CountryAbbreviation.CHL]: {
    code: "56",
    abbreviation: CountryAbbreviation.CHL,
    phoneDigits: 9,
    iso2: "cl",
  },
  [CountryAbbreviation.ECU]: {
    code: "593",
    abbreviation: CountryAbbreviation.ECU,
    phoneDigits: 9,
    iso2: "ec",
  },
  [CountryAbbreviation.GTM]: {
    code: "502",
    abbreviation: CountryAbbreviation.GTM,
    phoneDigits: 8,
    iso2: "gt",
  },
  [CountryAbbreviation.CUB]: {
    code: "53",
    abbreviation: CountryAbbreviation.CUB,
    phoneDigits: 8,
    iso2: "cu",
  },
  [CountryAbbreviation.SLV]: {
    code: "503",
    abbreviation: CountryAbbreviation.SLV,
    phoneDigits: 8,
    iso2: "sv",
  },
  [CountryAbbreviation.UK]: {
    code: "44",
    abbreviation: CountryAbbreviation.UK,
    phoneDigits: 11,
    iso2: "gb",
  },
  [CountryAbbreviation.FR]: {
    code: "33",
    abbreviation: CountryAbbreviation.FR,
    phoneDigits: 10,
    iso2: "fr",
  },
  [CountryAbbreviation.DE]: {
    code: "49",
    abbreviation: CountryAbbreviation.DE,
    phoneDigits: 11,
    iso2: "de",
  },
  [CountryAbbreviation.IT]: {
    code: "39",
    abbreviation: CountryAbbreviation.IT,
    phoneDigits: 10,
    iso2: "it",
  },
  [CountryAbbreviation.ES]: {
    code: "34",
    abbreviation: CountryAbbreviation.ES,
    phoneDigits: 9,
    iso2: "es",
  },
  [CountryAbbreviation.NL]: {
    code: "31",
    abbreviation: CountryAbbreviation.NL,
    phoneDigits: 9,
    iso2: "nl",
  },
  [CountryAbbreviation.SE]: {
    code: "46",
    abbreviation: CountryAbbreviation.SE,
    phoneDigits: 9,
    iso2: "se",
  },
  [CountryAbbreviation.NO]: {
    code: "47",
    abbreviation: CountryAbbreviation.NO,
    phoneDigits: 8,
    iso2: "no",
  },
  [CountryAbbreviation.CH]: {
    code: "41",
    abbreviation: CountryAbbreviation.CH,
    phoneDigits: 9,
    iso2: "ch",
  },
  [CountryAbbreviation.BE]: {
    code: "32",
    abbreviation: CountryAbbreviation.BE,
    phoneDigits: 9,
    iso2: "be",
  },
  [CountryAbbreviation.PL]: {
    code: "48",
    abbreviation: CountryAbbreviation.PL,
    phoneDigits: 9,
    iso2: "pl",
  },
  [CountryAbbreviation.PT]: {
    code: "351",
    abbreviation: CountryAbbreviation.PT,
    phoneDigits: 9,
    iso2: "pt",
  },
  [CountryAbbreviation.IE]: {
    code: "353",
    abbreviation: CountryAbbreviation.IE,
    phoneDigits: 9,
    iso2: "ie",
  },
  [CountryAbbreviation.GR]: {
    code: "30",
    abbreviation: CountryAbbreviation.GR,
    phoneDigits: 10,
    iso2: "gr",
  },
  [CountryAbbreviation.DK]: {
    code: "45",
    abbreviation: CountryAbbreviation.DK,
    phoneDigits: 8,
    iso2: "dk",
  }
  };

export const COUNTRIES_PHONE_CODES = [
  CountryCodes.USA,
  CountryCodes.MEX,
  CountryCodes.SLV,
  CountryCodes.ARG,
  CountryCodes.BE,
  CountryCodes.BRA,
  CountryCodes.CAN,
  CountryCodes.CHL,
  CountryCodes.COL,
  CountryCodes.CUB,
  CountryCodes.DK,
  CountryCodes.ECU,
  CountryCodes.FR,
  CountryCodes.DE,
  CountryCodes.GR,
  CountryCodes.GTM,
  CountryCodes.IE,
  CountryCodes.IT,
  CountryCodes.NL,
  CountryCodes.NO,
  CountryCodes.PER,
  CountryCodes.PL,
  CountryCodes.PT,
  CountryCodes.ES,
  CountryCodes.SE,
  CountryCodes.CH,
  CountryCodes.UK,
  CountryCodes.VEN,
] as const;

export const getCountriesPhoneInfo = () => {
  return COUNTRIES_PHONE_CODES.slice();
};
